/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import './component013.less';

const getImg = (img: string) => require(`../../../../../assets/${img}`).default;

interface IComponent013Item {
  img?: string;
  content: string;
  link?: string;
  linkDetail?: string;
}

interface IComponent013Props {
  title: string;
  subtitle1: string;
  content1: IComponent013Item[];
  subtitle2: string;
  content2: IComponent013Item[];
  className?: string;
}

const component013: React.FunctionComponent<IComponent013Props> = ({
  title,
  subtitle1,
  content1,
  subtitle2,
  content2,
  className,
}) => (
  <div className={`component component013 ${className}`}>
    <div
      className="component013-title"
      dangerouslySetInnerHTML={{ __html: title }}
    />
    <div
      className="component013-subtitle1"
      dangerouslySetInnerHTML={{ __html: subtitle1 }}
    />
    <div className="component013-content1">
      {content1.map((itm: IComponent013Item, idx: number) => (
        <>
          <div key={idx} className={`component013-content1-item r${idx + 1}`}>
            <div dangerouslySetInnerHTML={{ __html: itm.content }} />
            {itm.link && (
              <div className="linkDetail">
                （{itm.linkDetail}
                <a
                  href="https://cyberhub.hk/#/course/general-staff/900am"
                  key={`link${idx}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {itm.link}
                </a>
                ）
              </div>
            )}
          </div>
        </>
      ))}
    </div>
    <div
      className="component013-subtitle2"
      dangerouslySetInnerHTML={{ __html: subtitle2 }}
    />
    <div className="component013-content2">
      {content2.map((itm: IComponent013Item, idx: number) => (
        <div key={idx} className={`component013-content2-item r${idx + 1}`}>
          {itm.img && (
            <img
              className="component013-content2-item-img"
              src={getImg(itm.img)}
              alt=""
            />
          )}
          <div
            className="component013-content2-item-content"
            dangerouslySetInnerHTML={{ __html: itm.content }}
          />
        </div>
      ))}
    </div>
  </div>
);

export default component013;
